import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import {
  WithdrawnAuthorizationHistoryPreviewDto,
  WithdrawnAuthorizationInputDto,
  WithdrawnAuthorizationPreviewDto,
  WithdrawnAuthorizationSearchResultDto,
} from "../interfaces/WithdrawnAuthorization";
import { stringifyBgToIso } from "../common/utils/dateTime";
import { SearchLogPrintDto } from "../interfaces/SearchLogPrintDto";
import { WithRefNoResultsWrapperDto } from "../interfaces/WithRefNoResultsWrapperDto";

const apiEndpoint = "/withdrawnAuthorization";

const getWithdrawnAuthorizationsAsync = async (
  query: string
): Promise<AxiosResponse<WithRefNoResultsWrapperDto<WithdrawnAuthorizationSearchResultDto>>> => {
  return await http.get<WithRefNoResultsWrapperDto<WithdrawnAuthorizationSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getWithdrawnAuthorizationsCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getWithdrawnAuthorizationAsync = async (id: number): Promise<AxiosResponse<WithdrawnAuthorizationPreviewDto>> => {
  return await http.get<WithdrawnAuthorizationPreviewDto>(`${apiEndpoint}/${id}`);
};

const addWithdrawnAuthorizationAsync = async (
  model: WithdrawnAuthorizationInputDto
): Promise<AxiosResponse<WithdrawnAuthorizationInputDto>> => {
  return await http.post<WithdrawnAuthorizationInputDto>(apiEndpoint, model);
};

const updateWithdrawnAuthorizationAsync = async (
  model: WithdrawnAuthorizationInputDto
): Promise<AxiosResponse<WithdrawnAuthorizationInputDto>> => {
  return await http.put<WithdrawnAuthorizationInputDto>(`${apiEndpoint}/${model.withdrawnAuthorizationId}`, model);
};

const getWithdrawnAuthorizationHistoryAsync = async (
  id: number
): Promise<AxiosResponse<WithdrawnAuthorizationHistoryPreviewDto>> => {
  return await http.get<WithdrawnAuthorizationHistoryPreviewDto>(`${apiEndpoint}/history/${id}`);
};

const getWithdrawnAuthorizationIdByYearAsync = async (
  userId: number,
  registrationNumber: number,
  issueDate: Date
): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(
    `${apiEndpoint}/idByYear?userId=${userId}&registrationNumber=${registrationNumber}&issueDate=${stringifyBgToIso(
      issueDate
    )}`
  );
};

const getSearchLogAsync = async (refNo: string): Promise<AxiosResponse<SearchLogPrintDto>> => {
  return await http.get<SearchLogPrintDto>(`${apiEndpoint}/searchLog/${refNo}`);
};

export default {
  getWithdrawnAuthorizationsAsync,
  getWithdrawnAuthorizationsCountAsync,
  getWithdrawnAuthorizationAsync,
  addWithdrawnAuthorizationAsync,
  updateWithdrawnAuthorizationAsync,
  getWithdrawnAuthorizationHistoryAsync,
  getWithdrawnAuthorizationIdByYearAsync,
  getSearchLogAsync,
};
